import DoceboAPI, { DoceboLearningPlanDetail } from '@/lib/DoceboAPI';
import Vue from 'vue';
import Vuex, { ActionTree, GetterTree, MutationTree } from 'vuex';

interface LocalState {
  learningPlanDetail: { [learningPlanId: string]: DoceboLearningPlanDetail };
}

Vue.use(Vuex);

const doceboAPI = DoceboAPI.instance;

const namespaced = true;

const localState: LocalState = {
  learningPlanDetail: {},
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: GetterTree<LocalState, any> = {};

const mutations: MutationTree<LocalState> = {
  SET_LEARNING_PLAN_DETAIL: (state, learningPlan: DoceboLearningPlanDetail) => {
    Vue.set(
      state.learningPlanDetail,
      learningPlan.data.id.toString(),
      learningPlan
    );
  },
};

const actions: ActionTree<LocalState, unknown> = {
  GET_LEARNING_PLAN_DETAIL: (context, learningPlanId): Promise<void> =>
    doceboAPI
      .getLearningPlanDetail(learningPlanId)
      .then((learningPlanData: DoceboLearningPlanDetail) => {
        context.commit('SET_LEARNING_PLAN_DETAIL', learningPlanData);
      }),
};

export { namespaced, localState as state, getters, mutations, actions };
